import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'

import VideosNav from '../../../components/videos-nav'
import LookingForMore from '../../../components/looking-for-more'
import VideoList from '../../../components/video-list'
import ResourcesNav from '../../../components/resources-nav'
import Layout from '../../../components/layout'

export default class Videos extends React.Component {
  render() {
    const extra = get(this, 'props.data.extra.edges')
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    const metaDescription = `Extra Videos for teaching Math in PreK, Kindergarten, Elementary. Free teaching resources from ${siteTitle}`
    return (
      <Layout pageTitle="Extra Videos" description={metaDescription}>
        <ResourcesNav path={this.props.path} />
        <VideosNav path={this.props.path} />

        <h1>Extra Videos</h1>
        <VideoList resources={extra} />
        <hr />
        <LookingForMore />
      </Layout>
    )
  }
}

export const Query = graphql`
  query ExtraVideosQuery {
    site {
      siteMetadata {
        title
      }
    }
    extra: allContentfulResource(
      filter: { collections: { eq: "extra-videos" } }
      sort: { fields: slug }
    ) {
      edges {
        node {
          slug
          title
          description {
            childMarkdownRemark {
              html
            }
          }
          file {
            title
            file {
              url
            }
          }
        }
      }
    }
  }
`
